import type { RetreatEvent } from '../types/events'

/**
 * Built-in listing used only when the live events can't be reached
 * (offline, Supabase outage). Live content is managed at /admin.
 */
export const fallbackEvents: RetreatEvent[] = [
  {
    id: 'fallback-leonard-cohen',
    tagline: "Hey, that's no way to say goodbye",
    title: 'The Songs of Leonard Cohen',
    subtitle: 'A Tribute',
    performers: 'Husky Gawenda · Alma Zygier · Gabriella Cohen (Australia)',
    eventDate: '2026-08-20',
    doorsTime: '20:30',
    showTime: '21:00',
    address: '13 Kvutzat Avraham, Kfar Pines',
    posterUrl: 'https://cdn.magicpatterns.com/uploads/cq6oEWbpX9K7f5EWr5vmSC/1.jpg',
    posterAlt:
      'Poster for The Songs of Leonard Cohen, a tribute performed by Husky Gawenda, Alma Zygier and Gabriella Cohen at Pines Retreat on Thursday August 20',
    published: true,
    createdAt: null,
    updatedAt: null,
  },
]
